import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse } from '@core/shared/domain';

import {
  IndustryCatalog,
  IndustryCatalogInRelease,
  IndustryCatalogManufacturer,
  IndustryCatalogOpenTasks,
  IndustryCatalogSupplier,
  UpdateIndustryCatalog,
  UpdateSupplierOrManufacturer,
} from './industriekatalog';

@Injectable({ providedIn: 'root' })
export class IndustriekatalogeService {
  private readonly baseApiPath = '/api/contentmanagement/industrycatalogs';

  constructor(private readonly httpClient: HttpClient) {}

  getAll(params?: HttpParams): Observable<PageResponse<IndustryCatalog>> {
    return this.httpClient.get<PageResponse<IndustryCatalog>>(`${this.baseApiPath}`, { params });
  }

  getAllInFreigabe(): Observable<IndustryCatalogInRelease[]> {
    return this.httpClient.get<IndustryCatalogInRelease[]>(`${this.baseApiPath}/status`);
  }

  getIndustriekatalogDetail(id: string): Observable<IndustryCatalog> {
    return this.httpClient.get<IndustryCatalog>(`${this.baseApiPath}/${id}`);
  }

  updateIndustriekatalog(catalogId: string, dto: UpdateIndustryCatalog): Observable<void> {
    return this.httpClient.put<void>(`${this.baseApiPath}/${catalogId}`, dto);
  }

  getIndustriekatalogLieferanten(id: string, params?: HttpParams): Observable<PageResponse<IndustryCatalogSupplier>> {
    return this.httpClient.get<PageResponse<IndustryCatalogSupplier>>(`${this.baseApiPath}/${id}/supplier-mapping`, {
      params,
    });
  }

  updateLieferant({ id, designation, platformSupplierId }: UpdateSupplierOrManufacturer): Observable<void> {
    return this.httpClient.put<void>(`${this.baseApiPath}/${id}/supplier-mapping`, { designation, platformSupplierId });
  }

  getIndustriekatalogHersteller(
    id: string,
    params?: HttpParams,
  ): Observable<PageResponse<IndustryCatalogManufacturer>> {
    return this.httpClient.get<PageResponse<IndustryCatalogManufacturer>>(
      `${this.baseApiPath}/${id}/manufacturer-mapping`,
      { params },
    );
  }

  updateHersteller({ id, designation, platformSupplierId }: UpdateSupplierOrManufacturer): Observable<void> {
    return this.httpClient.put<void>(`${this.baseApiPath}/${id}/manufacturer-mapping`, {
      designation,
      platformSupplierId,
    });
  }

  getOpenTasks(id: string): Observable<IndustryCatalogOpenTasks> {
    return this.httpClient.get<IndustryCatalogOpenTasks>(`${this.baseApiPath}/${id}/opentasks`);
  }
  getIndustryCatalogsDatasources(): Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.baseApiPath}/datasources`);
  }
}
